<template>
  <UiTableWithPagination
    :loading="loading"
    :data="itemsWithPayload"
    :page="page"
    :per-page="perPage"
    :total="total"
    @update:page="$emit('update:page', $event)"
    @update:per-page="$emit('update:perPage', $event)"
    @row-click="goToOrder">
    <ElTableColumn prop="_id" label="ID" />

    <ElTableColumn prop="user" :label="$t('Base.Patient')" min-width="200px">
      <template #default="{ row }">
        <UiUserAvatarInfo :user="row.user" />
      </template>
    </ElTableColumn>

    <ElTableColumn
      prop="_biomaterialString"
      :label="$t('Laboratory.Biomaterial.Biomaterial')"
      min-width="240px" />

    <ElTableColumn prop="status" :label="$t('Base.Status')" min-width="200px">
      <template #default="{ row }">
        <OrderStatusTag :status="row.status" />
      </template>
    </ElTableColumn>
    <ElTableColumn prop="invoice.status" :label="$t('Base.Payment')" min-width="120px">
      <template #default="{ row }">
        <InvoiceStatusTag :status="row.invoice?.status" />
      </template>
    </ElTableColumn>

    <ElTableColumn prop="_createdDate" :label="$t('DateAndTime.CreatedAt')" />

    <ElTableColumn prop="actions" :label="$t('Base.Actions')" min-width="120px">
      <ElButton type="primary" text>
        <template #icon>
          <MiIcon icon="EYE" />
        </template>
        {{ $t('Base.Open') }}
      </ElButton>
    </ElTableColumn>
  </UiTableWithPagination>
</template>

<script>
import { LABORATORY_ORDER_ROUTE } from '@/router/laboratory.routes';
import { excludeTime } from '@/utils/dateAndTime.utils';
import OrderStatusTag from '@/components/laboratory/OrderStatusTag/index.vue';
import InvoiceStatusTag from '@/components/invoices/InvoiceStatusTag/index.vue';
import UiTableWithPagination from '@/components/ui/UiTableWithPagination/index.vue';
import { MiIcon } from '~shared/ui';

export default {
  name: 'OrdersTable',
  components: { UiTableWithPagination, InvoiceStatusTag, OrderStatusTag, MiIcon },
  props: {
    /** @type {Array<Invoice|object>} items */
    items: Array,
    loading: Boolean,
    page: Number,
    perPage: Number,
    total: Number,
  },
  computed: {
    itemsWithPayload() {
      return this.items.map((elem) => ({
        ...elem,

        _id: `#${elem.id}`,
        _biomaterialString: elem.biomaterials
          .map((biomaterial) => biomaterial.biomaterial_type_translate)
          .join(', '),
        _createdDate: excludeTime(elem.created_at),
      }));
    },
  },

  methods: {
    goToOrder(order) {
      this.$router.push({
        name: LABORATORY_ORDER_ROUTE.name,
        params: {
          id: order.id,
        },
      });
    },
  },
};
</script>

<style lang="scss" src="./index.scss" />
